import { isApolloGraphQLError, isGraphQLErrorArray, isStringErrorArray } from './errorGuards';
import { getErrorMessage } from './getErrorMessage';
const checkMessage = (errorMessage, message) => {
    return errorMessage.includes(message);
};
/**
 * Проверяет, содержит ли ошибка сообщение
 *
 * @param error - Ошибка неизвестного типа.
 * @param message - Сообщение
 * @returns true, если ошибка содержит сообщение, false в противном случае
 */
export const checkErrorMessage = (error, message) => {
    if (!error || !message) {
        return false;
    }
    if (isStringErrorArray(error)) {
        return error.some(error => checkMessage(error, message));
    }
    if (isGraphQLErrorArray(error)) {
        return error.some(error => checkMessage(error.message, message));
    }
    if (isApolloGraphQLError(error)) {
        return error.graphQLErrors.some(error => checkMessage(error.message, message));
    }
    return checkMessage(getErrorMessage(error), message);
};
